import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Controller } from "react-hook-form";
import { Typography, styled } from "@mui/material";

const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  columnGap: theme.spacing(1),
  alignItems: "center",
  minHeight: 40,
}));

const RadioButton = ({ row, data, control, name, width, defaultValue, clickControl, validation, disabled }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={validation}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <StyledRadioGroup
          aria-labelledby="radio-buttons-group-label"
          value={value || defaultValue}
          name={name || "radio-buttons-group"}
          row={row}
          onChange={clickControl}
          sx={{ width: width || "18.25vw", translate: "-8px 0" }}
        >
          {data?.map((item) => {
            return (
              <FormControlLabel
                sx={{ margin: 0 }}
                key={item?.value}
                value={item?.value || value}
                control={<Radio />}
                label={item?.label}
                onChange={onChange}
                disabled={disabled}
              />
            );
          })}
          {error && (
            <Typography variant="caption" color="error">
              {error.message}
            </Typography>
          )}
        </StyledRadioGroup>
      )}
    />
  );
};

export default RadioButton;
